"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _OzIcon = _interopRequireDefault(require("./../OzIcon/OzIcon.js"));

var _consts = require("./../consts.js");

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzPagination__Wrapper",
  componentId: "sc-os664t-0"
})(["\n  padding-top: 30px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 3px;\n  width: 100%;\n\n  &, & * {\n    box-sizing: border-box;\n    user-select: none;\n  }\n"]);

var Page = _styledComponents.default.div.withConfig({
  displayName: "OzPagination__Page",
  componentId: "sc-os664t-1"
})(["\n  margin: 2px;\n  border-radius: 4px;\n  text-align: center;\n  font-size: 14px;\n  cursor: pointer;\n  min-width: 26px;\n  height: 26px;\n  display: inline-flex;\n  justify-content: space-around;\n  align-items: center;\n\n  background-color: ", ";\n  border: 1px solid ", ";\n  color: ", ";\n  font-weight: ", ";\n  box-shadow: ", ";\n\n  &:hover{\n    border-color: ", ";\n    box-shadow: 0px 1px 2px #687FE239;\n  }\n"], function (props) {
  return props.active ? _consts.CHETWODEBLUE + "33" : "transparent";
}, function (props) {
  return props.active ? _consts.CHETWODEBLUE : "transparent";
}, function (props) {
  return props.active ? _consts.CHETWODEBLUE : _consts.BLACKPEARL;
}, function (props) {
  return props.active ? 700 : 400;
}, function (props) {
  return props.active ? "0px 1px 2px #687FE239" : "none";
}, _consts.CHETWODEBLUE);

var Control = _styledComponents.default.div.withConfig({
  displayName: "OzPagination__Control",
  componentId: "sc-os664t-2"
})(["\n  margin: 2px;\n  border-radius: 4px;\n  text-align: center;\n  font-size: 14px;\n  cursor: pointer;\n  min-width: 26px;\n  height: 26px;\n  display: inline-flex;\n  justify-content: space-around;\n  align-items: center;\n\n  border: 1px solid #CBCBCB;\n  background-color: #ffffff;\n  box-shadow: 0px 1px 2px #687FE239;\n\n  &:hover{\n    box-shadow: inset 0px 1px 2px #687FE239;\n    &::after{\n      background-color: ", "0A;\n    }\n  }\n  &:active{\n    &::after{\n      background-color: ", "20;\n    }\n  }\n\n"], _consts.CHETWODEBLUE, _consts.CHETWODEBLUE);

var SpacerControl = _styledComponents.default.div.withConfig({
  displayName: "OzPagination__SpacerControl",
  componentId: "sc-os664t-3"
})(["\n  margin: 2px;\n  cursor: pointer;\n  min-width: 26px;\n  height: 26px;\n  display: inline-flex;\n  justify-content: space-around;\n  align-items: center;\n\n  border: 1px solid transparent;\n\n"]);

var OzPagination = function OzPagination(_ref) {
  var _ref$totPages = _ref.totPages,
      totPages = _ref$totPages === void 0 ? 1 : _ref$totPages,
      _ref$currentPage = _ref.currentPage,
      currentPage = _ref$currentPage === void 0 ? 0 : _ref$currentPage,
      onChange = _ref.onChange;
  // let offset = currentPage-9;//Math.floor(totPages-currentPage/2)+1;
  return __jsx(Wrapper, null, currentPage >= 5 && totPages > 9 ? __jsx(Control, {
    onClick: function onClick() {
      return onChange(0);
    }
  }, __jsx(_OzIcon.default, {
    size: "16px",
    name: "arrow-start",
    color: _consts.BLACKPEARL
  })) : __jsx(SpacerControl, null), currentPage !== 0 ? __jsx(Control, {
    onClick: function onClick() {
      return onChange(currentPage - 1);
    }
  }, __jsx(_OzIcon.default, {
    size: "16px",
    name: "arrow-left",
    color: _consts.BLACKPEARL
  })) : __jsx(SpacerControl, null), (0, _toConsumableArray2.default)(Array(totPages)).map(function (v, i) {
    return i >= 0 && i < totPages && i < currentPage + 5 + (4 - currentPage > 0 ? 4 - currentPage : 0) && i > currentPage - 5 - (6 - (totPages - currentPage + 1) > 0 ? 6 - (totPages - currentPage + 1) : 0) ? __jsx(Page, {
      active: i === currentPage,
      key: i,
      onClick: function onClick() {
        return onChange(i);
      }
    }, i + 1) : null;
  }), currentPage !== totPages - 1 ? __jsx(Control, {
    onClick: function onClick() {
      return onChange(currentPage + 1);
    }
  }, __jsx(_OzIcon.default, {
    size: "16px",
    name: "arrow-right",
    color: _consts.BLACKPEARL
  })) : __jsx(SpacerControl, null), currentPage < totPages - 5 && totPages > 9 ? __jsx(Control, {
    onClick: function onClick() {
      return onChange(totPages - 1);
    }
  }, __jsx(_OzIcon.default, {
    size: "16px",
    name: "arrow-end",
    color: _consts.BLACKPEARL
  })) : __jsx(SpacerControl, null));
};

var _default = OzPagination;
exports.default = _default;